import React from 'react'
import type { FormikValues } from 'formik'
import { useField } from 'formik'

import { TtToggle } from '@23/react'

import type {
  FieldNameMatchingAcceptedType,
  FormikFormControlProps,
} from './index'

const TtToggleFormik = <FV extends FormikValues>({
  name,
  validate,
  value,
  invalid,
  errorText,
  ...props
}: FormikFormControlProps<'tt-toggle'> & {
  name: FieldNameMatchingAcceptedType<FV, boolean | undefined>
}) => {
  const [field, meta, helpers] = useField<boolean>({
    name,
    validate,
  })

  let checked

  switch (typeof field.value) {
    case 'string':
      checked = !(field.value === 'false' || field.value === '')
      break
    default:
      checked = !!field.value
  }

  return (
    <TtToggle
      {...props}
      name={field.name}
      value={value}
      checked={checked}
      onBlur={field.onBlur}
      onTt-change={(e) => {
        helpers.setValue(e.detail.checked)
      }}
      invalid={meta.touched && (!!meta.error || invalid)}
      errorText={meta.error ?? errorText}
    />
  )
}

export { TtToggleFormik }
